import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Sparkles, X } from 'lucide-react';
import { MAIL_API, mailAuth, REF_IN_SUBJECT, withRef } from './mailUtils';

/** Under the subject: "Add [26-3092] to the subject?" — from the thread, the recipient's jobs, and your recent jobs. */
export const SubjectSuggest = ({ to, cc, subject, chips = [], onPick }) => {
  const [items, setItems] = useState([]);
  const [hidden, setHidden] = useState(false);
  const timer = useRef(null);
  const hasRef = REF_IN_SUBJECT.test(subject || '');

  useEffect(() => {
    if (hasRef || hidden) { setItems([]); return undefined; }
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      axios.get(`${MAIL_API}/subject-suggestions`, { ...mailAuth(), params: { to, cc, subject, chips: chips.map(c => c.ref).join(',') } })
        .then(r => setItems(r.data.suggestions || [])).catch(() => setItems([]));
    }, 350);
    return () => clearTimeout(timer.current);
  }, [to, cc, hasRef, hidden]);

  if (hasRef || hidden || !items.length) return null;
  const src = { thread: 'this thread', recipient: 'their jobs', recent: 'your recent' };
  return (
    <div className="flex items-center gap-1.5 flex-wrap py-1.5" data-testid="mail-subject-suggest">
      <span className="text-[11px] text-slate-500 inline-flex items-center gap-1"><Sparkles className="w-3 h-3 text-amber-500" />Add the job number:</span>
      {items.slice(0, 6).map(s => (
        <button key={s.ref} type="button" onClick={() => onPick(withRef(s.ref, subject))} title={`${s.label} · ${src[s.source] || s.source}`}
          className={`text-[11px] font-mono font-bold px-2 py-0.5 rounded-md border transition-colors ${s.source === 'thread' ? 'bg-sky-50 border-sky-200 text-sky-800 hover:bg-sky-100' : s.source === 'recipient' ? 'bg-emerald-50 border-emerald-200 text-emerald-800 hover:bg-emerald-100' : 'bg-white border-slate-200 text-slate-700 hover:bg-slate-50'}`} data-testid={`mail-subject-suggest-${s.ref}`}>
          [{s.ref}]<span className="font-sans font-normal text-slate-500 ml-1 hidden sm:inline">{(s.label || '').split(' — ')[0].replace(/^Quote · /, 'Q · ').slice(0, 18)}</span>
        </button>
      ))}
      <button type="button" onClick={() => setHidden(true)} className="p-0.5 text-slate-400 hover:text-slate-700" title="Not for this email" data-testid="mail-subject-suggest-dismiss"><X className="w-3 h-3" /></button>
    </div>
  );
};
